import React from 'react';
export function Testimonials() {
  const reviews = [{
    initial: 'M',
    name: 'Marcos R.',
    loc: 'Rosario, Santa Fe',
    text: '"Pedí un cuadro con el logo de mi kiosco y quedó una locura. La gente entra y lo primero que hace es sacarle una foto. Vale cada peso."'
  }, {
    initial: 'S',
    name: 'Sofía L.',
    loc: 'Córdoba Capital',
    text: '"Lo regalé para el cumpleaños de mi novio y se quedó sin palabras. El embalaje llegó perfecto desde Venado hasta Córdoba. Totalmente recomendable."'
  }, {
    initial: 'F',
    name: 'Facundo M.',
    loc: 'Buenos Aires, CABA',
    text: '"Me mandaron el diseño antes de hacerlo, pedí un cambio de color y en el día me lo actualizaron. Muy buena atención y el resultado fue increíble."'
  }];
  return <section id="testimonios" className="py-[100px] px-[5%] relative z-10 bg-dark" data-id="element-148">
      <div className="text-[0.7rem] tracking-[4px] uppercase text-neon-pink mb-3" data-id="element-149">
        — Reviews
      </div>
      <h2 className="font-bebas text-[clamp(2.2rem,5vw,4rem)] leading-none mb-4" data-id="element-150">
        LO QUE DICEN
        <br data-id="element-151" />
        NUESTROS CLIENTES
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-[60px]" data-id="element-152">
        {reviews.map((review, i) => <div key={i} className="bg-dark-card border border-dark-border rounded-lg p-8 transition-colors duration-300 hover:border-neon-pink/40" data-id="element-153">
            <div className="text-neon-pink text-[0.9rem] tracking-[3px] mb-4" data-id="element-154">
              ★★★★★
            </div>
            <p className="text-[0.9rem] leading-[1.7] text-[#ccc] mb-6 italic" data-id="element-155">
              {review.text}
            </p>
            <div className="flex items-center gap-3" data-id="element-156">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-neon-pink to-neon-purple flex items-center justify-center text-base font-bold text-white shrink-0" data-id="element-157">
                {review.initial}
              </div>
              <div data-id="element-158">
                <div className="font-semibold text-[0.85rem]" data-id="element-159">
                  {review.name}
                </div>
                <div className="text-[0.75rem] text-text-muted" data-id="element-160">
                  {review.loc}
                </div>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}